import * as React from 'react'

import classNames from 'classnames/bind'

import ErrorBoundary from 'modules/core/components/ErrorBoundary'

import styles from './index.module.scss'

const cx = classNames.bind(styles)
type Directions =
  | 'vertical'
  | 'horizontal'
  | 'horizontal-2-cols-fixed-left'
  | 'horizontal-2-cols-left-1-third'
interface Props {
  actionItem?: React.ReactElement<any>
  // TODO: Deprecate
  direction: Directions
  zebra?: boolean
  type?: 'naked'
  sticky?: boolean
  padding?: boolean
}

const Panes: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  actionItem,
  direction,
  zebra,
  type,
  sticky = false,
  padding = true,
}) => {
  const renderActionItem = () => {
    if (!actionItem) return null

    return <div className={styles.actionItem}>{actionItem}</div>
  }

  const renderSection = (section: React.ReactElement<any> | null | undefined, i: number) => {
    if (!section) return null

    return (
      <div className={styles.section} key={i}>
        {section}
      </div>
    )
  }

  const className = cx(`sections-${direction}`, type, {
    sticky,
    zebra,
    'no-padding': !padding,
  })

  return (
    <ErrorBoundary>
      <div className={styles.panes}>
        <div className={className}>{React.Children.map(children as any, renderSection)}</div>
        {renderActionItem()}
      </div>
    </ErrorBoundary>
  )
}

export { Panes }
